// NPM
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { isNil, find } from 'lodash';

// HELPERS
import { toaster } from 'Helpers/toaster';
import { getWithExpiry } from 'Helpers/getset-with-expiry';

// ATOM
import { authActionStatusAtom, authPassportAtom, authErrorAtom } from 'Recoil/auth.atom';

// SERVICE
import { authLogout, emailVerification, resendEmailVerification } from 'Services/auth.services';

// COMPONENT
import VerificationForm from 'Components/auth/verification-form';

// ANT COMPONENTS
import { Loader } from '@life-line-lab/components-react';
import { Space } from 'antd';

// STYLE
import './verification.scss';

interface VerificationPageProps {}

const VerificationPage: React.FC<VerificationPageProps> = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const [status, setStatus] = useRecoilState<any>(authActionStatusAtom);
  const [authPassport, setAuthPassport] = useRecoilState<any>(authPassportAtom);
  const [error, setError] = useRecoilState<any>(authErrorAtom);

  const email = authPassport?.email;
  const userPID = authPassport.pid;

  console.log({ email, userPID });

  const isLoading = status.verify === 'loading' || status.sendVerify === 'loading';

  const scrollTop = React.useCallback(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, [])

  const handleSubmit = async (code: string) => {
    setStatus({ ...status, verifyCode: 'loading' });
    scrollTop();
    document.body.classList.add('overlay--open');

    const responseData = await emailVerification(userPID, code);
    console.log({ emailVerify: responseData });
    if (responseData !== false) {
      document.body.classList.remove('overlay--open');
      setStatus({ ...status, verifyCode: 'success' });
      toaster('success',
      <div dangerouslySetInnerHTML={{
        __html: t('toaster.verifyEmailSuccess')
      }} />);
      authLogout();
      setAuthPassport({});
      history.push('/login');
    }
    else {
      // document.body.classList.remove('overlay--open');
      setStatus({ ...status, verifyCode: 'error' });
      toaster('error',
      <div dangerouslySetInnerHTML={{
        __html: t('toaster.verifyEmailError')
      }} />);
    }

  }

  const handleRequestNewCode = async (e: any) => {
    e.preventDefault();

    setStatus({ ...status, resendCode: 'loading' });
    scrollTop();
    document.body.classList.add('overlay--open');
    const responseData = await resendEmailVerification(userPID);
    console.log({ resendEmailVerification: responseData });
    if (responseData) {
      document.body.classList.remove('overlay--open');
      setStatus({ ...status, resendCode: 'success' });
      toaster('success', t('toaster.sendVerificationEmailSuccess'))
    }
    else {
      document.body.classList.remove('overlay--open');
      setStatus({ ...status, resendCode: 'error' });
      toaster('error', t('toaster.sendVerificationEmailFailed'))
    }
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('pageTitle.verification')}</title>
        <meta name="robots" content="noindex"/>
      </Helmet>

      {isLoading &&
        <div className="overlay">
          <div className="overlay-inner">
            <Loader size="large" />
          </div>
        </div>
      }

      <div className="verification-page">
        <div className="verification-page--header">
          <h3 className="title">{t('title.verification')}</h3>
          <span
            className="description"
            dangerouslySetInnerHTML={{ __html: t('txt.verificationDescription', { email: email }) }}
          />
        </div>

        <div className="verification-page--main">
          <div className="verification-page--form">
            <VerificationForm
              resErr={error}
              status={status.verifyCode}
              onSubmit={handleSubmit}
            />
          </div>
        </div>

        <div className="verification-page--footer">
          <Space direction="vertical" size="middle">
            <div>{t('txt.didtReceiveEmail')}</div>

            <a href="" onClick={status.sendVerify === 'loading' ? () => {} : handleRequestNewCode}>
              {t('action.requestNewCode')}
            </a>
          </Space>
        </div>
      </div>
    </React.Fragment>
  )
}

export default VerificationPage;
